import React from "react";

import { connect } from "../i18n/connect";
import {
  getAuthToken,
  getUserID
} from "../redux/modules/auth/login/selector";
import { getInitialAuthCheckPending } from "../redux/modules/initialAuthCheck/selector";
import { fetchStaticPageRedirectsRoutine } from "../redux/modules/staticPageRedirects";
import {
  getStaticPageRedirectsForCurrentLocale,
  getStaticPageRedirectsLoading
} from "../redux/modules/staticPageRedirects/selector";
import { getLocale } from "../redux/modules/translations/selector";

export default function withStaticPageRedirects(WrappedComponent) {
  const mapStateToProps = state => ({
    locale: getLocale(state),
    authToken: getAuthToken(state),
    userID: getUserID(state),
    initialAuthCheckPending: getInitialAuthCheckPending(state),
    cachedMappings: getStaticPageRedirectsForCurrentLocale(state),
    staticPageRedirectsLoading: getStaticPageRedirectsLoading(state)
  });

  const mapDispatchToProps = {
    fetchStaticPageRedirects: fetchStaticPageRedirectsRoutine
  };

  @connect(mapStateToProps, mapDispatchToProps)
  class WithStaticPageRedirects extends React.Component {
    componentDidMount() {
      this.fetchRedirectsIfNeeded();
    }

    componentDidUpdate() {
      this.fetchRedirectsIfNeeded();
    }

    fetchRedirectsIfNeeded() {
      const {
        authToken,
        userID,
        initialAuthCheckPending,
        cachedMappings,
        staticPageRedirectsLoading,
        locale,
        fetchStaticPageRedirects
      } = this.props;

      const isGuestSession = !authToken && !userID;

      if (
        !isGuestSession ||
        initialAuthCheckPending ||
        Array.isArray(cachedMappings) ||
        staticPageRedirectsLoading
      ) {
        return;
      }

      fetchStaticPageRedirects({ locale });
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithStaticPageRedirects;
}
